import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-integration-images',
    templateUrl: './integration-images.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./integration-images.component.scss']
})
export class IntegrationImagesComponent implements OnInit {
    @Input() src1: string = "";
    @Input() src2: string = "";
    @Input() src3: string = "";
    @Input() src4: string = "";
    @Input() src5: string = "";
    @Input() src6: string = "";
    @Input() title1: string = "";
    @Input() title2: string = "";
    @Input() title3: string = "";
    @Input() title4: string = "";
    @Input() title5: string = "";
    @Input() title6: string = "";
    @Input() width: string = '150'; 
    @Input() width1: string = '180'; 
    constructor(
        public router: Router
    ) { }

    ngOnInit(): void { }

}